// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { IndexForms } from "@hex-insights/app-modules";
import { TypeFilterObject } from "@hex-insights/core";
import {
	CountrySelectField,
	EnrollmentApplicationGuardianSelectField,
	EnrollmentApplicationSelectField,
	GuardianSelectField,
} from "../../Forms";
import { EnrollmentApplicationGuardianFormValues } from "../../FormUtilities";
import { registry } from "../registry";
import * as CustomFilterFormValues from "./form-values-custom";

export type FilterFormValues = CustomFilterFormValues.StandardFilterFormValues &
	IndexForms.SearchFormValues &
	IndexForms.FilterFormValues;

export const initial: FilterFormValues = {
	...CustomFilterFormValues.initialStandardFilters,
	...IndexForms.initialSearchFormValues,
	...IndexForms.initialFilterFormValues,
};

export function getInitial(initialFormValues?: Partial<FilterFormValues>): FilterFormValues {
	return { ...initial, ...initialFormValues };
}

export const typeFilterObject: TypeFilterObject<FilterFormValues> = {
	...CustomFilterFormValues.standardFiltersTypeFilterObject,
	...IndexForms.searchFormValuesFilterObject,
	...IndexForms.filterFormValuesFilterObject,
};

export const advancedFilterInformation: IndexForms.AdvancedFilterInformation = {
	fieldOptions: [
		{ value: "givenName" },
		{ value: "middleName" },
		{ value: "familyName" },
		{ value: "nameOrder" },
		{ value: "dateOfBirth" },
		{ value: "gender" },
		{ value: "relationshipType" },
		{ value: "relationshipStatus" },
		{ value: "emailAddress" },
		{ value: "phoneNumber" },
		{ value: "addressLine1" },
		{ value: "addressLine2" },
		{ value: "addressCity" },
		{ value: "addressPostalCode" },
		{ value: "addressStateOrProvince" },
		{ value: "isPrimary" },
		{ value: "isFinancialContact" },
		{ value: "isEmergencyContact" },
		{ value: "isAuthorizedForPickup" },
		{ value: "livesWithStudent" },
		{ value: "isPrimaryOnApplication" },
		{ value: "addressCountry" },
		{ value: "enrollmentApplication" },
		{ value: "guardian" },
		{ value: "sameAddressGuardians" },
		{ value: "targetAddressGuardian" },
	],
	fieldComparisonOptions: {
		givenName: IndexForms.stringComparisonOptions,
		middleName: IndexForms.stringComparisonOptions,
		familyName: IndexForms.stringComparisonOptions,
		nameOrder: IndexForms.enumComparisonOptions,
		dateOfBirth: [...IndexForms.dateComparisonOptions, ...IndexForms.nullableComparisonOptions],
		gender: IndexForms.stringComparisonOptions,
		relationshipType: IndexForms.stringComparisonOptions,
		relationshipStatus: [...IndexForms.enumComparisonOptions, ...IndexForms.nullableComparisonOptions],
		emailAddress: IndexForms.stringComparisonOptions,
		phoneNumber: IndexForms.stringComparisonOptions,
		addressLine1: IndexForms.stringComparisonOptions,
		addressLine2: IndexForms.stringComparisonOptions,
		addressCity: IndexForms.stringComparisonOptions,
		addressPostalCode: IndexForms.stringComparisonOptions,
		addressStateOrProvince: IndexForms.stringComparisonOptions,
		isPrimary: IndexForms.booleanComparisonOptions,
		isFinancialContact: IndexForms.booleanComparisonOptions,
		isEmergencyContact: IndexForms.booleanComparisonOptions,
		isAuthorizedForPickup: IndexForms.booleanComparisonOptions,
		livesWithStudent: IndexForms.booleanComparisonOptions,
		isPrimaryOnApplication: IndexForms.booleanComparisonOptions,
		addressCountry: [...IndexForms.singularEdgeComparisonOptions, ...IndexForms.nullableSingularEdgeComparisonOptions],
		enrollmentApplication: IndexForms.singularEdgeComparisonOptions,
		guardian: [...IndexForms.singularEdgeComparisonOptions, ...IndexForms.nullableSingularEdgeComparisonOptions],
		sameAddressGuardians: IndexForms.multipleEdgeComparisonOptions,
		targetAddressGuardian: [
			...IndexForms.singularEdgeComparisonOptions,
			...IndexForms.nullableSingularEdgeComparisonOptions,
		],
	},
	fieldComparisonTranslations: {
		givenName: IndexForms.stringComparisonTranslations,
		middleName: IndexForms.stringComparisonTranslations,
		familyName: IndexForms.stringComparisonTranslations,
		nameOrder: IndexForms.getRadioComparisonTranslations(EnrollmentApplicationGuardianFormValues.nameOrderOptions),
		dateOfBirth: { ...IndexForms.dateComparisonTranslations, ...IndexForms.nullableComparisonTranslations },
		gender: IndexForms.stringComparisonTranslations,
		relationshipType: IndexForms.stringComparisonTranslations,
		relationshipStatus: {
			...IndexForms.getRadioComparisonTranslations(EnrollmentApplicationGuardianFormValues.relationshipStatusOptions),
			...IndexForms.nullableComparisonTranslations,
		},
		emailAddress: IndexForms.stringComparisonTranslations,
		phoneNumber: IndexForms.stringComparisonTranslations,
		addressLine1: IndexForms.stringComparisonTranslations,
		addressLine2: IndexForms.stringComparisonTranslations,
		addressCity: IndexForms.stringComparisonTranslations,
		addressPostalCode: IndexForms.stringComparisonTranslations,
		addressStateOrProvince: IndexForms.stringComparisonTranslations,
		isPrimary: IndexForms.booleanComparisonTranslations,
		isFinancialContact: IndexForms.booleanComparisonTranslations,
		isEmergencyContact: IndexForms.booleanComparisonTranslations,
		isAuthorizedForPickup: IndexForms.booleanComparisonTranslations,
		livesWithStudent: IndexForms.booleanComparisonTranslations,
		isPrimaryOnApplication: IndexForms.booleanComparisonTranslations,
		addressCountry: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				CountrySelectField.Select,
				CountrySelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
		enrollmentApplication: IndexForms.getSingularEdgeComparisonTranslations(
			EnrollmentApplicationSelectField.Select,
			EnrollmentApplicationSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		guardian: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				GuardianSelectField.Select,
				GuardianSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
		sameAddressGuardians: IndexForms.getMultipleEdgeComparisonTranslations(
			EnrollmentApplicationGuardianSelectField.Select,
			EnrollmentApplicationGuardianSelectField.MultiSelect,
			IndexForms.placeholderFilterInformation,
		),
		targetAddressGuardian: {
			...IndexForms.getSingularEdgeComparisonTranslations(
				EnrollmentApplicationGuardianSelectField.Select,
				EnrollmentApplicationGuardianSelectField.MultiSelect,
				IndexForms.placeholderFilterInformation,
			),
			...IndexForms.nullableSingularEdgeComparisonTranslations,
		},
	},
};

registry.register("EnrollmentApplicationGuardian", advancedFilterInformation, {
	addressCountry: "Country",
	enrollmentApplication: "EnrollmentApplication",
	guardian: "Guardian",
	sameAddressGuardians: "EnrollmentApplicationGuardian",
	targetAddressGuardian: "EnrollmentApplicationGuardian",
});
